import graphql from 'babel-plugin-relay/macro';
import createMutation from '../../helpers/createMutation';

const mutation = graphql`
  mutation ActionCancelHoldMutation($input: Action__CancelHoldInput!) {
    actionCancelHold(input: $input) { 
        entity { 
          id
          dbId
          availability
          entityStates {
            id
            dbId
            state
            dueDate
            userId
          }
        }
        error
    }
  }
`;

const commit = input =>
  createMutation({
    mutation,

    variables: {
      input
    }
  });

export default { commit };
